import blazy from 'gridstrap/lib/blazy';
import $ from 'gridstrap/lib/gs-zepto';

import { screenshotCarousel } from '../screenshot-carousel';


export class GSScreenshotStripItem {

	//
	// Properties
	//

	private root;
	private image;

	get src() {
		return this.image.data('gsScreenshotStripImage');
	}

	//
	// Initializations & Event Handlers
	//

	constructor(root) {
		this.root = $(root);
		this.image = this.root.find('.gs-ScreenshotStrip-image');

		if (this.src) {
			this.root.on('click', () => screenshotCarousel.open(this.src));
		}

		setTimeout(() => blazy.revalidate(), 1000);
	}

	gsOnDestroy() {
		this.root.off();
	}
}
